import type { CrmConnectionForm } from './gp_scopes'
import type {
    CreateCrmConnectionInput,
    CrmConnection,
    OutboundConfig,
    UpdateCrmConnectionInput
} from './crm_integration_service'

export function crmFormFromConnection(conn: CrmConnection): CrmConnectionForm {
    const cfg: OutboundConfig = conn.outbound_config ?? {}
    return {
        crm_type: conn.crm_type,
        name: conn.name,
        direction: conn.direction,
        endpoint_base: cfg.endpoint_base ?? '',
        path: cfg.path ?? '',
        method: cfg.method ?? 'POST',
        authType: cfg.auth?.type ?? 'header',
        authHeaderName: cfg.auth?.header_name ?? '',
        authToken: '',
        headers: (cfg.headers ?? []).map((h) => ({ ...h })),
        bodyAttributes: (cfg.body_attributes ?? []).map((b) => ({ ...b })),
        fieldMapping: (cfg.field_mapping ?? []).map((m) => ({ ...m }))
    }
}

export function crmFormToOutboundConfig(form: CrmConnectionForm): OutboundConfig {
    const config: OutboundConfig = {
        endpoint_base: form.endpoint_base.trim() || undefined,
        path: form.path.trim() || undefined,
        method: form.method.trim() || undefined,
        auth: {
            type: form.authType,
            header_name: form.authHeaderName.trim() || undefined
        },
        headers: form.headers.filter((h) => h.name.trim() !== ''),
        body_attributes: form.bodyAttributes.filter((b) => b.path.trim() !== ''),
        field_mapping: form.fieldMapping.filter((m) => m.source.trim() !== '' && m.target.trim() !== '')
    }

    const token = form.authToken.trim()
    if (token !== '') {
        config.auth_token = token
    }

    return config
}

export function crmFormToConnectionInput(form: CrmConnectionForm): CreateCrmConnectionInput & UpdateCrmConnectionInput {
    return {
        crm_type: form.crm_type.trim(),
        name: form.name.trim(),
        direction: form.direction,
        outbound_config: crmFormToOutboundConfig(form)
    }
}
